import { useEffect, useRef, useState } from "react";
import type { Product } from "@/mocks/products";

interface Props {
  product: Product;
}

interface Review {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  date: string;
  title: string;
  content: string;
  tag: string;
  verified: boolean;
  helpful: number;
  img?: string;
}

const categoryReviews: Record<string, Review[]> = {
  dzi: [
    {
      id: "r1",
      name: "陳雅婷",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20elegant%20taiwanese%20woman%2035%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_dzi1&orientation=squarish",
      rating: 5,
      date: "2025.12.08",
      title: "戴上之後整個人氣場都不一樣了",
      content: "買了九眼天珠手鍊送給先生，他說戴上之後工作特別順，連客戶都說他最近氣色很好。包裝非常精緻，附的能量說明卡讓我們更了解天珠的意涵。瓏靖的品質真的沒話說，下次還要再來！",
      tag: "九眼天珠",
      verified: true,
      helpful: 42,
      img: "https://readdy.ai/api/search-image?query=nine%20eye%20Tibetan%20dzi%20bead%20bracelet%20worn%20on%20wrist%20close%20up%20natural%20light%20warm%20tone%20lifestyle%20photography&width=200&height=200&seq=rv_dzi1&orientation=squarish",
    },
    {
      id: "r2",
      name: "林建宏",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20businessman%2045%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_dzi2&orientation=squarish",
      rating: 5,
      date: "2025.11.22",
      title: "收藏多年天珠，這家品質最讓我放心",
      content: "我收藏天珠超過十年，對品質非常挑剔。瓏靖的天珠紋路清晰、能量感強，一拿到手就知道是真品。客服也很專業，詳細解說了每顆天珠的特性，讓我買得很安心。",
      tag: "天珠收藏家",
      verified: true,
      helpful: 38,
    },
    {
      id: "r3",
      name: "王淑芬",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2050%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_dzi3&orientation=squarish",
      rating: 5,
      date: "2025.11.05",
      title: "送給媽媽的生日禮物，她超喜歡",
      content: "幫媽媽挑了蓮花天珠吊墜，她說蓮花代表純潔，非常喜歡這個寓意。禮盒包裝很高級，打開的瞬間媽媽眼睛都亮了。客服幫我附上了手寫祝福卡，細心到讓人感動。",
      tag: "送禮首選",
      verified: true,
      helpful: 29,
    },
    {
      id: "r4",
      name: "張志明",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2038%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_dzi4&orientation=squarish",
      rating: 4,
      date: "2025.10.18",
      title: "品質很好，配戴舒適",
      content: "三眼天珠手鍊的做工非常細緻，925純銀扣頭質感很好，戴了兩個月都沒有褪色。唯一小建議是希望能提供更多手圍尺寸選擇，不過客服說可以客製，這點很貼心。",
      tag: "三眼天珠",
      verified: true,
      helpful: 21,
    },
    {
      id: "r5",
      name: "李美玲",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2028%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_dzi5&orientation=squarish",
      rating: 5,
      date: "2025.10.02",
      title: "做了能量測驗才知道自己適合天珠",
      content: "一開始不知道要買什麼，做了網站上的能量測驗，推薦我天珠系列。買了財神天珠之後，感覺整個人的財運真的有提升，工作上也接到了幾個大案子。很感謝瓏靖的專業推薦！",
      tag: "能量測驗推薦",
      verified: true,
      helpful: 35,
    },
  ],
  crystal: [
    {
      id: "r1",
      name: "吳雅雯",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2030%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_cry1&orientation=squarish",
      rating: 5,
      date: "2025.12.10",
      title: "紫水晶真的讓我睡眠改善了",
      content: "買了天然紫水晶手鍊，放在床頭一個月後，睡眠品質明顯改善，做夢也比較少了。水晶的顏色很漂亮，在陽光下會折射出美麗的光芒。包裝精緻，很適合送禮。",
      tag: "紫水晶",
      verified: true,
      helpful: 56,
      img: "https://readdy.ai/api/search-image?query=amethyst%20purple%20crystal%20bracelet%20worn%20on%20wrist%20close%20up%20natural%20light%20warm%20tone%20lifestyle%20photography&width=200&height=200&seq=rv_cry1&orientation=squarish",
    },
    {
      id: "r2",
      name: "黃俊傑",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2032%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_cry2&orientation=squarish",
      rating: 5,
      date: "2025.11.28",
      title: "金髮晶招財效果超明顯",
      content: "戴了金髮晶手鍊三個月，業績真的有提升，連主管都說我最近狀態很好。水晶裡面的金色髮絲在燈光下非常漂亮，每次看都覺得很療癒。品質很好，值得投資！",
      tag: "金髮晶",
      verified: true,
      helpful: 44,
    },
    {
      id: "r3",
      name: "蔡佳穎",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2025%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_cry3&orientation=squarish",
      rating: 5,
      date: "2025.11.15",
      title: "粉水晶讓我的感情運提升了",
      content: "單身很久了，朋友推薦我買粉水晶。戴了兩個月後真的認識了一個很好的對象！不知道是不是心理作用，但整個人的心情也變得更開朗了。水晶的粉色很溫柔，很喜歡。",
      tag: "粉水晶",
      verified: true,
      helpful: 38,
    },
    {
      id: "r4",
      name: "鄭文凱",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2040%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_cry4&orientation=squarish",
      rating: 4,
      date: "2025.10.25",
      title: "黑曜石守護效果很強",
      content: "買了黑曜石手鍊給自己，感覺戴上之後整個人的氣場變得更穩定，不容易受到外界負能量影響。工作壓力大的時候摸摸手鍊，心情會平靜很多。品質很好，推薦給需要守護的朋友。",
      tag: "黑曜石",
      verified: true,
      helpful: 27,
    },
    {
      id: "r5",
      name: "許淑惠",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2045%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_cry5&orientation=squarish",
      rating: 5,
      date: "2025.10.08",
      title: "碧璽的顏色太美了，每天都想戴",
      content: "碧璽手鍊的顏色層次非常豐富，每個角度看都不一樣，真的很美！戴出去很多人問我在哪裡買的。瓏靖的服務很好，有任何問題都能快速得到回覆，是值得信賴的品牌。",
      tag: "碧璽",
      verified: true,
      helpful: 31,
    },
  ],
  jade: [
    {
      id: "r1",
      name: "劉雅琳",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20elegant%20taiwanese%20woman%2042%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_jade1&orientation=squarish",
      rating: 5,
      date: "2025.12.05",
      title: "翡翠手鐲的質感超越預期",
      content: "買了翡翠手鐲送給婆婆，她說是她見過最漂亮的翡翠手鐲。顏色均勻、質地細膩，在陽光下透著美麗的翠綠光澤。附的鑑定書讓人很放心，知道買到的是真品。",
      tag: "翡翠手鐲",
      verified: true,
      helpful: 48,
      img: "https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20bangle%20bracelet%20worn%20on%20wrist%20close%20up%20natural%20light%20warm%20tone%20lifestyle%20photography%20elegant&width=200&height=200&seq=rv_jade1&orientation=squarish",
    },
    {
      id: "r2",
      name: "趙建國",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2055%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_jade2&orientation=squarish",
      rating: 5,
      date: "2025.11.20",
      title: "送給太太的結婚紀念禮物",
      content: "結婚二十週年送給太太翡翠觀音吊墜，她感動到哭了。觀音的雕工非常精細，每個細節都很到位。瓏靖的包裝很有質感，打開的瞬間就像在開一份珍貴的禮物。",
      tag: "翡翠觀音",
      verified: true,
      helpful: 39,
    },
    {
      id: "r3",
      name: "方淑芳",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2048%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_jade3&orientation=squarish",
      rating: 5,
      date: "2025.11.08",
      title: "平安扣是最好的護身符",
      content: "買了翡翠平安扣給兒子出國留學用，希望他平平安安。玉石的質感很好，顏色漂亮，兒子說很喜歡，每天都戴著。瓏靖的客服很耐心地幫我挑選最適合的款式，非常感謝。",
      tag: "平安扣",
      verified: true,
      helpful: 33,
    },
    {
      id: "r4",
      name: "謝志豪",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2035%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_jade4&orientation=squarish",
      rating: 4,
      date: "2025.10.22",
      title: "白玉如意的寓意很好",
      content: "買了白玉如意吊墜放在辦公室，感覺整個工作環境的氣場都變好了。白玉的質感溫潤，摸起來很舒服。唯一希望能有更多尺寸選擇，不過整體非常滿意。",
      tag: "白玉如意",
      verified: true,
      helpful: 22,
    },
    {
      id: "r5",
      name: "林美華",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2038%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_jade5&orientation=squarish",
      rating: 5,
      date: "2025.10.05",
      title: "翡翠珠鍊是我的傳家寶",
      content: "買了翡翠珠鍊，打算傳給女兒。每一顆珠子的顏色和大小都很均勻，串在一起非常漂亮。瓏靖的品質讓我很放心，這種等級的翡翠珠鍊在市面上很難找到，值得珍藏。",
      tag: "翡翠珠鍊",
      verified: true,
      helpful: 45,
    },
  ],
  thangka: [
    {
      id: "r1",
      name: "陳宗翰",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2050%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_thk1&orientation=squarish",
      rating: 5,
      date: "2025.12.01",
      title: "綠度母唐卡的能量非常強大",
      content: "供奉綠度母唐卡三個月，家裡的氣氛明顯變得更和諧，家人之間的關係也改善了很多。唐卡的畫工非常精細，顏色鮮豔，是真正的藝術品。附的文化說明書讓我更了解綠度母的意涵。",
      tag: "綠度母唐卡",
      verified: true,
      helpful: 52,
      img: "https://readdy.ai/api/search-image?query=Tibetan%20thangka%20painting%20displayed%20on%20wall%20home%20interior%20warm%20light%20spiritual%20atmosphere%20cultural%20art%20collectible&width=200&height=200&seq=rv_thk1&orientation=squarish",
    },
    {
      id: "r2",
      name: "蘇雅慧",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2044%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_thk2&orientation=squarish",
      rating: 5,
      date: "2025.11.18",
      title: "財神唐卡讓我的事業起飛",
      content: "在辦公室供奉財神唐卡後，業績真的有明顯提升，連公司的整體業績都好了很多。唐卡的品質非常好，顏色飽滿，金粉的部分在燈光下閃閃發光，非常莊嚴。",
      tag: "財神唐卡",
      verified: true,
      helpful: 41,
    },
    {
      id: "r3",
      name: "楊文彬",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2048%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_thk3&orientation=squarish",
      rating: 5,
      date: "2025.11.02",
      title: "蓮花生大士佛牌隨身守護",
      content: "買了蓮花生大士佛牌隨身佩戴，感覺整個人的氣場變得更穩定，遇到困難的時候心裡也比較踏實。佛牌的做工非常精細，金色的光澤很莊嚴。是我見過品質最好的藏傳佛牌。",
      tag: "蓮花生大士",
      verified: true,
      helpful: 36,
    },
    {
      id: "r4",
      name: "周淑娟",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20woman%2060%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_thk4&orientation=squarish",
      rating: 5,
      date: "2025.10.20",
      title: "白度母佛牌送給長輩最適合",
      content: "買了白度母佛牌送給媽媽，她說戴上之後身體感覺比較好，睡眠也改善了。白度母象徵長壽健康，是送給長輩最有意義的禮物。瓏靖的包裝很精緻，媽媽非常喜歡。",
      tag: "白度母",
      verified: true,
      helpful: 28,
    },
    {
      id: "r5",
      name: "吳建明",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20man%2042%20years%20old%20soft%20natural%20light%20warm%20tone%20minimalist%20background%20professional%20headshot&width=80&height=80&seq=av_thk5&orientation=squarish",
      rating: 5,
      date: "2025.10.08",
      title: "釋迦牟尼唐卡是最珍貴的收藏",
      content: "買了釋迦牟尼佛唐卡供奉在家中，整個家的氣氛都變得更莊嚴祥和。唐卡的畫工精細到令人嘆為觀止，每個細節都充滿了藝術家的虔誠與用心。附的收藏證書讓這件藝術品更有價值。",
      tag: "釋迦牟尼唐卡",
      verified: true,
      helpful: 47,
    },
  ],
};

const ratingStats: Record<string, { avg: number; total: number; dist: number[] }> = {
  dzi: { avg: 4.9, total: 128, dist: [0, 1, 2, 8, 117] },
  crystal: { avg: 4.8, total: 96, dist: [0, 1, 3, 10, 82] },
  jade: { avg: 4.9, total: 74, dist: [0, 0, 2, 6, 66] },
  thangka: { avg: 4.9, total: 58, dist: [0, 0, 1, 5, 52] },
};

function StarRow({ rating, size = "text-sm" }: { rating: number; size?: string }) {
  return (
    <>
      {[1, 2, 3, 4, 5].map((s) => (
        <i
          key={s}
          className={`${s <= rating ? "ri-star-fill" : "ri-star-line"} text-[#c9a96e] ${size}`}
        ></i>
      ))}
    </>
  );
}

export default function ProductDetailReviews({ product }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [helpfulClicked, setHelpfulClicked] = useState<Set<string>>(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const reviews = categoryReviews[product.category] ?? categoryReviews.dzi;
  const stats = ratingStats[product.category] ?? ratingStats.dzi;

  const handleHelpful = (id: string) => {
    setHelpfulClicked((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <section className="py-16 bg-[#faf8f4]" ref={ref}>
      <div
        className={`max-w-7xl mx-auto px-6 md:px-16 transition-all duration-1000 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-12">
          <div className="w-1 h-8 bg-[#8b6f47] rounded-full"></div>
          <h2
            className="text-[#2d2520] font-bold"
            style={{ fontSize: "1.75rem", fontFamily: "'Noto Serif TC', serif" }}
          >
            顧客真實評價
          </h2>
          <span
            className="ml-2 px-3 py-1 bg-[#f0e8dc] text-[#8b6f47] text-sm font-medium rounded-full"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            {stats.total} 則評價
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Left: Rating Summary */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl border border-[#e8e0d5] p-8 sticky top-28">
              {/* Big Score */}
              <div className="text-center mb-6">
                <div
                  className="text-[#2d2520] font-bold leading-none mb-2"
                  style={{ fontSize: "4rem", fontFamily: "'Noto Serif TC', serif" }}
                >
                  {stats.avg}
                </div>
                <div className="flex items-center justify-center gap-1 mb-2">
                  <StarRow rating={Math.round(stats.avg)} size="text-xl" />
                </div>
                <p
                  className="text-[#a89880] text-sm"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  共 {stats.total} 位顧客評價
                </p>
              </div>

              {/* Rating Distribution */}
              <div className="space-y-2.5">
                {[5, 4, 3, 2, 1].map((star) => {
                  const count = stats.dist[star - 1];
                  const pct = Math.round((count / stats.total) * 100);
                  return (
                    <div key={star} className="flex items-center gap-3">
                      <span
                        className="text-[#7a6a5a] text-sm w-4 flex-shrink-0"
                        style={{ fontFamily: "'Noto Serif TC', serif" }}
                      >
                        {star}
                      </span>
                      <i className="ri-star-fill text-[#c9a96e] text-sm flex-shrink-0"></i>
                      <div className="flex-1 h-2 bg-[#f0e8dc] rounded-full overflow-hidden">
                        <div
                          className="h-full bg-[#c9a96e] rounded-full"
                          style={{
                            width: visible ? `${pct}%` : "0%",
                            transition: "width 1s ease",
                          }}
                        ></div>
                      </div>
                      <span
                        className="text-[#a89880] text-sm w-8 text-right flex-shrink-0"
                        style={{ fontFamily: "'Noto Serif TC', serif" }}
                      >
                        {count}
                      </span>
                    </div>
                  );
                })}
              </div>

              {/* Divider */}
              <div className="border-t border-[#e8e0d5] my-6"></div>

              {/* Highlights */}
              <div>
                <p
                  className="text-[#7a6a5a] text-sm font-medium mb-3"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  顧客最常提到
                </p>
                <div className="flex flex-wrap gap-2">
                  {["品質精良", "包裝精緻", "能量感強", "值得收藏", "送禮首選", "客服專業"].map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 bg-[#faf8f4] border border-[#e8e0d5] text-[#7a6a5a] text-xs rounded-full"
                      style={{ fontFamily: "'Noto Serif TC', serif" }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              {/* Verified Badge */}
              <div className="mt-6 flex items-center gap-2 p-3 bg-[#f0f9f0] rounded-xl border border-[#c8e6c9]">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-fill text-[#4a7a52] text-base"></i>
                </div>
                <p
                  className="text-[#4a7a52] text-xs leading-[1.5]"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  所有評價均來自已驗證購買顧客
                </p>
              </div>
            </div>
          </div>

          {/* Right: Review Cards */}
          <div className="lg:col-span-2 space-y-5">
            {reviews.map((review, i) => (
              <div
                key={review.id}
                className="bg-white rounded-2xl border border-[#e8e0d5] p-6 hover:border-[#c9a96e]/50"
                style={{
                  opacity: visible ? 1 : 0,
                  transform: visible ? "translateY(0)" : "translateY(16px)",
                  transition: `opacity 0.6s ease ${i * 80}ms, transform 0.6s ease ${i * 80}ms, border-color 0.3s`,
                }}
              >
                {/* Review Header */}
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 border-2 border-[#f0e8dc]">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <span
                          className="text-[#2d2520] font-semibold text-[0.9375rem]"
                          style={{ fontFamily: "'Noto Serif TC', serif" }}
                        >
                          {review.name}
                        </span>
                        {review.verified && (
                          <span className="flex items-center gap-1 px-2 py-0.5 bg-[#f0f9f0] border border-[#c8e6c9] rounded-full">
                            <i className="ri-checkbox-circle-fill text-[#4a7a52] text-xs"></i>
                            <span
                              className="text-[#4a7a52] text-[0.6875rem]"
                              style={{ fontFamily: "'Noto Serif TC', serif" }}
                            >
                              已驗證購買
                            </span>
                          </span>
                        )}
                      </div>
                      <div className="flex items-center gap-2 mt-0.5">
                        <div className="flex items-center gap-0.5">
                          <StarRow rating={review.rating} size="text-sm" />
                        </div>
                        <span
                          className="text-[#a89880] text-xs"
                          style={{ fontFamily: "'Noto Serif TC', serif" }}
                        >
                          {review.date}
                        </span>
                      </div>
                    </div>
                  </div>
                  <span
                    className="px-2.5 py-1 bg-[#faf8f4] border border-[#e8e0d5] text-[#8b6f47] text-xs rounded-full whitespace-nowrap flex-shrink-0"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {review.tag}
                  </span>
                </div>

                {/* Review Title */}
                <h4
                  className="text-[#2d2520] font-semibold mb-2 text-[1rem]"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  {review.title}
                </h4>

                {/* Review Content + Optional Image */}
                <div className={`flex gap-4 ${review.img ? "items-start" : ""}`}>
                  <p
                    className="text-[#7a6a5a] leading-[1.8] text-[0.9375rem] flex-1"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {review.content}
                  </p>
                  {review.img && (
                    <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 border border-[#e8e0d5]">
                      <img
                        src={review.img}
                        alt="顧客分享"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  )}
                </div>

                {/* Helpful */}
                <div className="flex items-center gap-3 mt-4 pt-4 border-t border-[#f0e8dc]">
                  <span
                    className="text-[#a89880] text-xs"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    這則評價對您有幫助嗎？
                  </span>
                  <button
                    onClick={() => handleHelpful(review.id)}
                    className={`flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs cursor-pointer transition-all duration-200 whitespace-nowrap ${
                      helpfulClicked.has(review.id)
                        ? "bg-[#8b6f47] border-[#8b6f47] text-white"
                        : "bg-white border-[#e8e0d5] text-[#7a6a5a] hover:border-[#8b6f47] hover:text-[#8b6f47]"
                    }`}
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {helpfulClicked.has(review.id)
                      ? <i className="ri-thumb-up-fill text-sm"></i>
                      : <i className="ri-thumb-up-line text-sm"></i>
                    }
                    有幫助（{helpfulClicked.has(review.id) ? review.helpful + 1 : review.helpful}）
                  </button>
                </div>
              </div>
            ))}

            {/* Load More Hint */}
            <div className="text-center pt-2">
              <p
                className="text-[#a89880] text-sm"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                顯示 5 則評價，共 {stats.total} 則 · 如需更多評價請透過 LINE 聯繫我們
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
